import { Link as RouterLink, Outlet } from 'react-router-dom'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CloseIcon from '@mui/icons-material/Close'
import PoweredByFooter from '../../pages/applications/referenceRequest/Footer'

// A distraction-free frame for taking a course. MainFrame leaves out the
// app's own navigation and logo on /training/course/* routes, because CPD UK
// guidance keeps branding off content screens. No organisation name or logo
// appears in a course either: the courses are AmbuNet's, not the
// organisation's. This supplies the plain frame in their place, with a
// small "Powered by AmbuNet" line under the content on every course page.
const FocusLayout = () => (
  <Box
    sx={{
      // Its own scroll area: the app shell does not scroll the page itself.
      height: '100vh',
      width: '100%',
      overflowY: 'auto',
      bgcolor: '#F8FAFC',
      fontFamily: 'Arial, Helvetica, sans-serif',
      // Printing (the question bank has a Print button) needs normal flow,
      // or only the visible part of the page would print.
      '@media print': { height: 'auto', overflow: 'visible', bgcolor: '#fff' },
    }}
  >
    <Box
      component="header"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        px: { xs: 1.5, sm: 3 },
        py: 1,
        bgcolor: '#fff',
        borderBottom: '1px solid #CBD5E1',
        '@media print': { display: 'none' },
      }}
    >
      <Typography sx={{ fontFamily: 'inherit', fontWeight: 700, fontSize: '1rem', color: '#242F40' }}>Training</Typography>
      <Button
        component={RouterLink}
        to="/mandatory-training"
        startIcon={<CloseIcon />}
        sx={{ fontFamily: 'inherit', textTransform: 'none', fontSize: '1rem', minHeight: 44, color: '#1F3D7C' }}
      >
        Exit course
      </Button>
    </Box>
    <Box component="main" sx={{ maxWidth: 1240, mx: 'auto', p: { xs: 1.5, sm: 3 } }}>
      <Outlet />
    </Box>
    <Box sx={{ '@media print': { display: 'none' } }}>
      <PoweredByFooter />
    </Box>
  </Box>
)

export default FocusLayout
